<template>
  <v-btn
    :color="color"
    :small="small"
    :disabled="disabled"
    :outline="outline"
    :fab="fab"
    :round="round"
    :depressed="depressed"
    :loading="loading"
    @click="handleClick"
    :block="block"
    :style="{ width: fixedWidth ? `${fixedWidth}px` : null }"
    :class="{
      'small-font-size': smallFontSize,
      'medium-font-size': mediumFontSize
    }"
  >
    <template v-if="!custom">
      <template v-if="icon && right && !left">{{ text }}</template>
      <template v-else-if="!icon">{{ text }}</template>
      <img v-if="icon && left" class="step-icon" src="@/assets/svg/arrow-left.svg" />
      <template v-if="icon && left && !right">{{ text }}</template>
      <img v-if="!loading && icon && right" class="step-icon" src="@/assets/svg/arrow-right.svg" />
    </template>
    <template v-else>
      <slot name="custom"></slot>
    </template>
  </v-btn>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    icon: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      required: true
    },
    round: {
      type: Boolean,
      default: true
    },
    fab: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    depressed: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    handleClick: {
      type: Function,
      default: () => false
    },
    custom: {
      type: Boolean,
      default: false
    },
    smallFontSize: {
      type: Boolean,
      default: false
    },
    mediumFontSize: {
      type: Boolean,
      default: false
    },
    fixedWidth: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      isLoading: "getIsLoading"
    })
  }
};
</script>

<style scoped lang="scss">
.progress {
  margin-left: 10px;
}

.small-font-size {
  /deep/ .v-btn__content {
    font-size: 14px !important;
  }
}

/deep/ .v-btn__content {
  overflow: hidden;
}

.medium-font-size {
  /deep/ .v-btn__content {
    font-size: 16px !important;
  }
}
</style>
